import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BodyComponent } from 'app/body/body.component';
import { ExtratoComponent } from 'app/extrato/extrato.component';
import { HomeComponent } from 'app/home/home.component';
import { LojaCarrinhoComponent } from 'app/loja/loja-carrinho/loja-carrinho.component';
import { LojaVitrineComponent } from 'app/loja/loja-vitrine/loja-vitrine.component';
import { LojaComponent } from 'app/loja/loja.component';
import { PedidoComponent } from 'app/loja/pedido/pedido.component';
import { FaqComponent } from 'app/menu-superior/faq/faq.component';
import { EpwdResetComponent } from 'app/menu-superior/meu-cadastro/epwd-reset/epwd-reset.component';
import { EpwdComponent } from 'app/menu-superior/meu-cadastro/epwd/epwd.component';
import { MeuCadastroComponent } from 'app/menu-superior/meu-cadastro/meu-cadastro.component';
import { AnexosComponent } from 'app/menu-superior/sac/anexos/anexos.component';
import { DetalheComponent } from 'app/menu-superior/sac/detalhe/detalhe.component';
import { SacFormComponent } from 'app/menu-superior/sac/form/sac-form.component';
import { SacComponent } from 'app/menu-superior/sac/sac.component';
import { ConfirmacaoNovoPagamentoComponent } from 'app/pagamento/confirmacao-novo-pagamento/confirmacao-novo-pagamento.component';
import { NovoPagamentoIndividualComponent } from 'app/pagamento/novo-pagamento-individual/novo-pagamento-individual.component';
import { NovoPagamentoLoteComponent } from 'app/pagamento/novo-pagamento-lote/novo-pagamento-lote.component';
import { NovoPagamentoComponent } from 'app/pagamento/novo-pagamento/novo-pagamento.component';
import { PagamentoComponent } from 'app/pagamento/pagamento.component';
import { PoliticaTermoComponent } from 'app/politica-termo/politica-termo.component';
import { Rotas } from 'app/resources/classes/rotas';
import { AuthGuard } from 'app/resources/services/index';
import { BancariaComponent } from 'app/transferencia/bancaria/bancaria.component';
import { BandeiradoComponent } from 'app/transferencia/bandeirado/bandeirado.component';
import { CartaoComponent } from 'app/transferencia/cartao/cartao.component';
import { TransferenciaComponent } from 'app/transferencia/transferencia.component';
import { CestaComponent } from 'app/vale-presente/cesta/cesta.component';
import { ParceirosComponent } from 'app/vale-presente/parceiros/parceiros.component';
import { ValePedidoComponent } from 'app/vale-presente/vale-pedido/vale-pedido.component';
import { ValePresenteComponent } from 'app/vale-presente/vale-presente.component';
import { VitrineComponent } from 'app/vale-presente/vitrine/vitrine.component';
import { VoucherConfirmarComponent } from 'app/voucher/voucher-confirmar/voucher-confirmar.component';
import { VoucherDadosTransferenciaComponent } from 'app/voucher/voucher-dados-transferencia/voucher-dados-transferencia.component';
import { VoucherResgatarComponent } from 'app/voucher/voucher-resgatar/voucher-resgatar.component';
import { VoucherSucessoComponent } from 'app/voucher/voucher-sucesso/voucher-sucesso.component';

const routes: Routes = [
  {
    path: '',
    component: BodyComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: HomeComponent, canActivate: [AuthGuard] },
      { path: Rotas.VOUCHER_CONFIRMAR, component: VoucherConfirmarComponent, canActivate: [AuthGuard] },
      { path: Rotas.VOUCHER_RESGATAR, component: VoucherResgatarComponent, canActivate: [AuthGuard] },
      { path: Rotas.VOUCHER_DADOS_TRANSFERENCIA, component: VoucherDadosTransferenciaComponent, canActivate: [AuthGuard] },
      { path: Rotas.VOUCHER_SUCESSO, component: VoucherSucessoComponent, canActivate: [AuthGuard] },
      { path: 'saldo', component: ExtratoComponent, canActivate: [AuthGuard] },
      {
        path: 'transferencias', canActivate: [AuthGuard], children: [
          { path: '', component: TransferenciaComponent, canActivate: [AuthGuard] },
          { path: 'nova', component: BancariaComponent, canActivate: [AuthGuard] },
          { path: 'cartao/nova', component: CartaoComponent, canActivate: [AuthGuard] },
          { path: 'pontos/reais', component: BandeiradoComponent, canActivate: [AuthGuard] }
        ]
      },
      {
        path: 'pagamentos', canActivate: [AuthGuard], children: [
          { path: '', component: PagamentoComponent, canActivate: [AuthGuard] },
          { path: 'novo', component: NovoPagamentoComponent, canActivate: [AuthGuard] },
          { path: 'individual', component: NovoPagamentoIndividualComponent, canActivate: [AuthGuard] },
          { path: 'lote', component: NovoPagamentoLoteComponent, canActivate: [AuthGuard] },
          { path: 'confirmacao', component: ConfirmacaoNovoPagamentoComponent, canActivate: [AuthGuard] }
        ]
      },
      {
        path: 'valepresente', canActivate: [AuthGuard], children: [
          { path: '', component: ValePresenteComponent, canActivate: [AuthGuard] },
          { path: 'parceiros', component: ParceirosComponent, canActivate: [AuthGuard] },
          { path: 'vitrine', component: VitrineComponent, canActivate: [AuthGuard] },
          { path: 'cesta', component: CestaComponent, canActivate: [AuthGuard] },
          { path: 'pedido', component: ValePedidoComponent, canActivate: [AuthGuard] }
        ]
      },
      {
        path: 'loja', canActivate: [AuthGuard], children: [
          { path: '', component: LojaComponent, canActivate: [AuthGuard] },
          { path: 'vitrine', component: LojaVitrineComponent, canActivate: [AuthGuard] },
          { path: 'carrinho', component: LojaCarrinhoComponent, canActivate: [AuthGuard] },
          { path: 'pedido', component: PedidoComponent, canActivate: [AuthGuard] }
        ]

      },
      { path: 'cartao', component: MeuCadastroComponent, canActivate: [AuthGuard] },
      { path: 'cartao/epwd', component: EpwdComponent, canActivate: [AuthGuard] },
      { path: 'cartao/epwd/reset', component: EpwdResetComponent, canActivate: [AuthGuard] },
      { path: 'perguntas-frequentes', component: FaqComponent, canActivate: [AuthGuard] },
      {
        path: 'sac', canActivate: [AuthGuard], children: [
          { path: '', component: SacComponent, canActivate: [AuthGuard] },
          { path: 'detalhe', component: DetalheComponent, canActivate: [AuthGuard] },
          { path: 'anexos', component: AnexosComponent, canActivate: [AuthGuard] },
          { path: 'form', component: SacFormComponent, canActivate: [AuthGuard] }
        ]
      },
      {
        path: 'politicas-e-termos', component: PoliticaTermoComponent, canActivate: [AuthGuard]
      }
    ]
  }

];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  declarations: [
  ]
})
export class BodyRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/body/body.routing.module.ts